import React from 'react';

import Faq from 'gatsby-core-theme/src/components/atoms/faq';

  export default ( props) => <Faq {...props}  icon="plus" />;